export enum SedsCheckboxOptions {
  AFTER = 'after',
  BEFORE = 'before',
}
